import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-277" data-mp="3fznvbprkvj3h">
      <div className="mx-auto max-w-5xl" data-id="element-278" data-mp="3fxuni758astw">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-279" data-mp="3b0uilzk47w4d">
          ⭐ What other dentists are saying
        </h2>

        <div className="mt-5 flex flex-col items-center" data-id="element-280" data-mp="36wwefafxnv4g">
          <div className="flex items-center gap-1" aria-hidden="true" data-id="element-281" data-mp="31yuwwty5o3v3">
            {Array.from({
            length: 5
          }).map((_, index) => <StarIcon key={index} className="h-5 w-5 fill-gold text-gold" data-id="element-282" data-mp="2x11sa5ci3hwx" data-mpi={index} />)}
          </div>
          <p className="mt-2 font-display text-2xl font-bold text-ink" data-id="element-283" data-mp="2s3tai5v9lfw7">4.9/5</p>
          <p className="mt-1 max-w-md text-center text-[13.5px] text-brand-900/65" data-id="element-284" data-mp="v8wuwec8fset">
            Dentists using visual systems to structure their resin veneer cases.
          </p>
        </div>

        <ul className="mt-9 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-285" data-mp="h4dc6jitvk34">
          {testimonials.map(item => <li key={item.name} className="flex h-full flex-col rounded-2xl border border-brand-100 bg-white p-5" data-id="element-286" data-mp="m2ydyndqabto">
              <div className="flex items-center gap-3" data-id="element-287" data-mp="c7wmvlzw6zog">
                <img src={item.photo} alt={`Photo of ${item.name}`} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brand-100" width={112} height={112} loading="lazy" data-id="element-288" data-mp="zwfwq5ylbkin" />
                <div className="min-w-0" data-id="element-289" data-mp="v5g257cy1ejb">
                  <p className="text-[15px] font-bold leading-tight text-ink" data-id="element-290" data-mp="v44x747ri0qm">{item.name}</p>
                  <p className="mt-0.5 text-[12.5px] font-medium text-brand-800/70" data-id="element-291" data-mp="1iuih27g70ta4">
                    {item.country}
                  </p>
                </div>
              </div>
              <div className="mt-3 flex items-center gap-0.5" aria-hidden="true" data-id="element-292" data-mp="1xi8ymxpvot7q">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-293" data-mp="1sgtdz6rm4opv" data-mpi={index} />)}
              </div>
              <blockquote className="mt-3 text-[14.5px] leading-relaxed text-brand-900/75" data-id="element-294" data-mp="1jihsfj5lsh4a">
                “{item.quote}”
              </blockquote>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-295" data-mp="19sepor8ojosr">
          <CTAButton label="I want to analyze my veneers with a system" note="$27 USD · Lifetime access · 7-day guarantee" data-id="element-296" data-mp="19rmuvimwpv3j" />
        </div>
      </div>
    </section>;
}